module.exports = "data:image/gif;base64,R0lGODlhIAAgAPMAAP///3x8fMHBwcXFxc7OztDQ0NLS0tra2tzc3Ofn5+jo6Pnk5Pzx8f///wAAAAAAACH5BAEAAAAALAAAAAAgACAAAATVEMhJq7046827/2D4NWSJIGVKeiQzBHAsw0XBqM3FKG0x/7PCalJ6xYSkAzCGagwWFOcStmsZm8ZAITqFEWBKJOK3lTQYAV5W9g20Aw1gGRCHN3yxg6LQftdnBmZxTXhLAmMDfzIGJTAlhV0oQIxdMAJTijEGkFM2lzOZNJxdfQ16oVqjU30wiXKoS6yOryQLa0sFAkqzZESVS6g5ZrxSMgMKClmhQ3SFCSk+YzEKvK3MZgjHwoLAMQvbLDTUMXU3IsskieAjaDE3KSJEd0jx9fb3+BIRADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/ambulance/CHeadNW_S7.gif
// module id = DZX/
// module chunks = 50